module.exports = __webpack_public_path__ + "static/media/apple-touch-icon-180.9fe282b2.png";